<ham-modal
    [title]="'aumico_integration_sharepoint_connect_modal_title' | i18next"
    [hideFooter]="true"
    [size]="'sm'"
    (cancel)="onCancel()"
>
    <div class="sharepoint-modal-body">
        <!-- Step 1: explainer + optional display name -->
        <section *ngIf="step === 'welcome'">
            <p class="sharepoint-modal-body__paragraph">
                {{ 'aumico_integration_sharepoint_connect_intro' | i18next }}
            </p>

            <!-- The scopes aumico will ask Microsoft for. Shown here because a tenant that
                 has already granted admin consent never sees Microsoft's own consent screen. -->
            <ul class="sharepoint-modal-body__permissions">
                <li *ngFor="let permission of requestedPermissions">
                    <span class="sharepoint-modal-body__permission-label">
                        {{ permission.labelKey | i18next }}
                    </span>
                    <small
                        *ngIf="permission.descriptionKey != null"
                        class="sharepoint-modal-body__hint"
                    >
                        {{ permission.descriptionKey | i18next }}
                    </small>
                </li>
            </ul>

            <div class="sharepoint-modal-body__field">
                <label for="sharepointDisplayName">
                    {{ 'aumico_integration_setup_displayname_label' | i18next }}
                </label>
                <input
                    hamInput
                    id="sharepointDisplayName"
                    type="text"
                    [(ngModel)]="customDisplayName"
                    [placeholder]="'aumico_integration_setup_displayname_placeholder' | i18next"
                />
                <small class="sharepoint-modal-body__hint">
                    {{ 'aumico_integration_sharepoint_displayname_help' | i18next }}
                </small>
            </div>

            <div class="sharepoint-modal-body__actions">
                <!-- No [disabled]: display name is OPTIONAL for SharePoint (the BE names the
                     connection after the tenant when it is left blank). -->
                <ham-button variant="primary" size="sm" (buttonClick)="onStartConsent()">
                    {{ 'aumico_integration_sharepoint_connect_button' | i18next }}
                </ham-button>
                <ham-button variant="primary" size="sm" [outline]="true" (buttonClick)="onCancel()">
                    {{ 'aumico_button_cancel' | i18next }}
                </ham-button>
            </div>
        </section>

        <!-- Step 2: waiting for the Microsoft popup to come back -->
        <section *ngIf="step === 'awaiting_consent'" class="sharepoint-modal-body__loading">
            <div class="sharepoint-modal-body__spinner"></div>
            <p class="sharepoint-modal-body__paragraph">
                {{ 'aumico_integration_sharepoint_awaiting_consent' | i18next }}
            </p>
            <ham-button variant="primary" size="sm" [outline]="true" (buttonClick)="onCancel()">
                {{ 'aumico_button_cancel' | i18next }}
            </ham-button>
        </section>

        <!-- Step 3: error. Success has no view: the modal closes and manage takes over. -->
        <section *ngIf="step === 'error'" class="sharepoint-modal-body__error">
            <div class="sharepoint-modal-body__error-icon">⚠</div>
            <h3 class="sharepoint-modal-body__title">
                {{ 'aumico_integration_status_error_title' | i18next }}
            </h3>
            <p class="sharepoint-modal-body__error-message">{{ errorMessage }}</p>
            <div class="sharepoint-modal-body__actions">
                <ham-button variant="primary" size="sm" (buttonClick)="onRetryFromError()">
                    {{ 'aumico_button_retry' | i18next }}
                </ham-button>
                <ham-button variant="primary" size="sm" [outline]="true" (buttonClick)="onCancel()">
                    {{ 'aumico_button_cancel' | i18next }}
                </ham-button>
            </div>
        </section>
    </div>
</ham-modal>
